<div class="modal-header">
    <p class="modal-title"><strong>User profile history</strong></p>
      <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>
<div class=form-group>

    <p *ngIf="data.startDate"> Employee joined on {{ data.startDate | localDate:'dd-MMM-yy'}} </p>
</div>

<div class=form-group>
    <div class="modal-body">
        <div class="table-responsive-sm">
            <table class="table table-bordered">
                <tr>
                    <th>Visa type </th>
                    <th>Current status</th>
                    <th>Requested on </th>
                    <th>Completed Date</th>
                </tr>

                <tr *ngFor="let imm of data.immigrationProfiles">

                    <td>{{imm.visaType.displayText }}</td>
                    <td> {{imm.status.displayText}}</td>
                    <td>{{imm.submissionDate | localDate:'dd-MMM-yy HH:mm:ss'}} </td>
                    <td>{{imm.completionDate | localDate:'dd-MMM-yy HH:mm:ss'}} </td>
                </tr>
            </table>
        </div>
        <div class="row" *ngIf="tableLoading==null? false : !tableLoading">
            <div class="col-md">
                <div class="page-nav">
                    <nav>
                        <ul class="pagination ">
                            <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
                                <a class="page-link" (click)="pageChange(1)">
                                    <span aria-hidden="true">&laquo;&laquo;</span>
                                </a>
                            </li>
                            <li class="page-item" [ngClass]="{'disabled': currentPage - 1 < 1}">
                                <a class="page-link" (click)="pageChange(currentPage - 1)" aria-label="Previous">
                                    <span aria-hidden="true">&laquo;</span>
                                </a>
                            </li>
                            <li [ngClass]="{'active': pageNumber + i === currentPage }" class="page-item"
                                *ngFor="let i of pages">
                                <a (click)="pageChange(pageNumber + i)" class="page-link">{{pageNumber + i}}</a>
                            </li>
                            <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
                                <a class="page-link" (click)="pageChange(currentPage + 1)" aria-label="Next">
                                    <span aria-hidden="true">&raquo;</span>
                                </a>
                            </li>
                            <li class="page-item" [ngClass]="{'disabled': currentPage + 1 > totalPages}">
                                <a class="page-link" (click)="pageChange(totalPages)">
                                    <span aria-hidden="true">&raquo;&raquo;</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <select (change)="onSelectChanges()" [(ngModel)]="data.sortParameters.itemsPerPage"
                        class="form-control form-control-sm">
                        <option *ngFor="let count of changeCount" [value]="count">{{count}}</option>
                    </select>
                    <p>Per page</p>
                </div>
            </div>
        </div>
    </div>